module.exports = __webpack_public_path__ + "assets/apple-icon-76x76.5264d462.png";